import ApiService from './../api/ApiService';
import * as Config from '../constants/Config';
import Urls from './../api/Urls';
import CustomPrice from './../models/CustomPrice';
import {omit} from 'lodash';

export function getCustomPrices(params) {
    return new ApiService({
        baseURL: Config.default.API_HOTEL,
        endpoint: params.hotelId ? Urls.CUSTOM_PRICE_LIST_BY_HOTEL_ID : Urls.CUSTOM_PRICE_LIST,
        params: omit(params, ['hotelId', 'hotel_id']),
        endpointParams: params.hotelId && {id: params.hotelId},
        parser: pricesDataParser,
    }).get();
}

export function getCustomPriceDetail(id) {
    return new ApiService({
        baseURL: Config.default.API_HOTEL,
        endpoint: Urls.CUSTOM_PRICE_DETAIL,
        endpointParams: { id },
        parser: (data) => new CustomPrice(data.price),
    }).get();
}

export function createCustomPrice(customPrice) {
    return new ApiService({
        baseURL: Config.default.API_HOTEL,
        endpoint: Urls.CUSTOM_PRICE_CREATE,
        parser: (data) => new CustomPrice(data.price),
    }).post({price: customPrice.export()});
}

export function updateCustomPrice(customPrice) {
    return new ApiService({
        baseURL: Config.default.API_HOTEL,
        endpoint: Urls.CUSTOM_PRICE_DETAIL,
        endpointParams: { id: customPrice.id },
        parser: (data) => new CustomPrice(data.price),
    }).put({price: customPrice.export()});
}

const pricesDataParser = (data) => ({
    prices: (data.prices || []).map(item => new CustomPrice(item)),
    pageIndex: Math.floor(data.offset/data.limit) + 1,
    pageSize: data.limit,
    totalCount: data.total
});